import React from "react";
import "./PaperWorkEstimateCard.scss"
import { MovePaperWorkCard } from "components/movePaperWorkCard";
import { MoveListCard } from "components/moveListCard";
import { Button } from "components/button";
import { EstimatorDetailCard } from "components/estimatorDetailCard";
import { OrignCompanyDetailCard } from "components/OrignCompanyDetailCard";
import { CompanyDetailCard } from "components/companyDetailCard";
import { DestinationCompanyDetailCard } from "components/DestinationCompanyDetailCard";
import { InfoCard } from "components/infoCard";
import { CardLayout } from "components/cardLayout";
import { getEstFlowEstimateDetails, getEstimatorInventory } from "../../core/services/moveDetailsByCustomer"
import { getCustomerDetails } from 'core/services/getCustomerDetailsService'
//@ts-ignore
// import SimpleLineIcon from 'react-simple-line-icons';
// import '../../../node_modules/font-awesome/css/font-awesome.min.css'
import { MdClose } from "react-icons/md";
//@ts-ignore
import SignatureCanvas from 'react-signature-canvas'
import { FormGroup, Validators, FormBuilder, FormControl } from "react-reactive-form";
import { client } from "App";
import { saveSignatures } from '../../core/services/saveSignatures'
import { navigate } from "@reach/router";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import Spinner from '../spinner/spinner';
//import { sign } from "crypto";

export interface PaperWorkEstimateCardProps {

}

export interface PaperWorkEstimateCardState {
    transportData: any;
    responseEstDetail: any,
    inventoryData: any,
    inventoryUniqueRow: any,
    trimmedDataURFirst: any,
    trimmedDataURSecond: any,
    btnText: any
    base64FistSign: any,
    base64SecondSign: any,
    isValid: boolean;
    Customer: any;
    loading: boolean;
    updateSign: boolean
}
var signs = [
    { id: "1", sign: "" },
    { id: "2", sign: "" }
];

class PaperWorkEstimateCard extends React.Component<PaperWorkEstimateCardProps, PaperWorkEstimateCardState> {
    private _isMounted: boolean = false
    sigCanvasFirst: any;
    sigCanvasSecond: any;
    firstSignPadRef: any;

    constructor(props: PaperWorkEstimateCardProps) {
        super(props);
        //debugger;
        this.state = {
            transportData: [],
            responseEstDetail: {},
            inventoryData: [],
            inventoryUniqueRow: [],
            trimmedDataURFirst: "",
            trimmedDataURSecond: "",
            btnText: "Book Now",
            base64FistSign: "",
            base64SecondSign: "",
            isValid: false,
            Customer: JSON.parse(localStorage.getItem("customerDetails") || '{}'),
            loading: true,
            updateSign: false
        };


    }


    componentDidMount() {

        console.log("componentDidMount")
        //this.setState({loading:false});
        this._isMounted = true;
        var cid = (localStorage.getItem("CID") || "");
        var securetoken = localStorage.getItem("securetoken") || "";
        //this.getData(cid);
        Promise.all([
            //this.getCustomerDetails(cid),
            this.getEstFlowEstimateDetails(cid),
            this.getEstimatorInventory(cid)
        ]).then((response: any[]) => {
            if (this._isMounted) {
                // let responseCustDetail = response[0][0];
                // localStorage.setItem("customerDetails", JSON.stringify(responseCustDetail));
                // var custDetails = JSON.parse(localStorage.getItem("customerDetails") || "{}");

                const responseEstDetail = response[0][0];

                this.setState({ responseEstDetail: responseEstDetail });
                //localStorage.setItem("estFlowEstimateDetails", JSON.stringify(responseEstDetail));


                this.setState({ loading: false });

                var inventory = response[1];
                this.setState({ inventoryData: inventory });
                //localStorage.setItem("estInventory", JSON.stringify(inventory));

                var inventoryUniqueNames: any = [];
                const inventoryObj = this.state.inventoryData.filter((item: { name: any; }) => {
                    var idx = inventoryUniqueNames.findIndex((x: { name: any; }) => x.name == item.name);
                    if (idx <= -1) {
                        inventoryUniqueNames.push({ name: item.name });
                    }
                });
                this.setState({ inventoryUniqueRow: inventoryUniqueNames, loading: false });



                // setTimeout(() => {
                //     this.writeSignToCanvas();
                //     this.setState({updateSign:true});
                // }, 100)
            }
        });
        //this.setState({loading:false});
    }

    componentWillUnmount() {
        this._isMounted = false;
        console.log("componentWillUnmount")
    }

    async getCustomerDetails(cid: string, securetoken: string) {
        return await getCustomerDetails(cid, securetoken)
    }

    async getEstFlowEstimateDetails(cid: string) {
        return await getEstFlowEstimateDetails(cid)
    }

    async getEstimatorInventory(cid: string) {
        return await getEstimatorInventory(cid)
    }

    render() {


        return (
            this.state.loading ? <Spinner /> :
                <div>
                    <div className="movepaper-container">
                        <div className="container ">
                            <OrignCompanyDetailCard />
                            <MovePaperWorkCard />
                            <DestinationCompanyDetailCard />
                        </div>

                    </div>
                </div>
        );
    }
}

export default PaperWorkEstimateCard;